import { ReactNode } from 'react';
import * as Styles from './ProfileNavItem.styles';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';

export type ProfileNavigationItem = {
  icon: ReactNode;
  title: string;
  href: string;
  hide?: boolean;
  external?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  state?: Record<string, any>;
};

export default function ProfileNavItem({
  href,
  icon,
  title,
  hide,
  external,
  state,
}: ProfileNavigationItem) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (external) {
      window.open(href, '_blank', 'noopener,noreferrer');
    } else {
      navigate(href, state ? { state } : undefined);
    }
  };

  if (hide) {
    return null;
  }

  return (
    <Styles.ProfileNavItemContainer onClick={handleClick}>
      {icon}
      <Typography fontSize="16px" lineHeight="16px" fontWeight={550}>
        {title}
      </Typography>
      <ChevronRightRoundedIcon sx={{ ml: 'auto' }} />
    </Styles.ProfileNavItemContainer>
  );
}
